/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import restApiClient from '../../../services/restApiClient';
import dayjs from 'dayjs';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import DayJsUtils from '@date-io/dayjs';
import { useSecurity } from '../../../extensions/hooks';
import SecuredItem from '../../../components/securedItem';
import {
  Hidden,
  Select,
  FileCsv,
  FilePdf,
  AutoDiv,
  MenuItem,
  Container,
  InputLabel,
  FormControl,
  FormHelperText,
  SelectContainer,
  HeaderContainer,
  FooterContainer,
  ExportCsvButton,
  ExportPdfButton,
  ButtonContainer,
  CircularProgress,
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from './styles';
import Report from '../../../forms/report';
import ReportDailyBankingHistory from '../../../pdf/reportDailyBankingHistory';
import ReportMonthlyBankingHistory from '../../../pdf/reportMonthlyBankingHistory';

function DreReportList() {
  const [exportCsvVisible, setExportCsvVisible] = useState(false);
  const [exportPdfVisible, setExportPdfVisible] = useState(false);
  const [dateIntervalVisible, setDateIntervalVisible] = useState(false);
  const [selectUnitVisible, setSelectUnitVisible] = useState(false);
  const [dateIntervalMonthVisible, setDateIntervalMonthVisible] =
    useState(false);
  const [selectedDateFrom, setSelectedDateFrom] = useState(null);
  const [selectedDateTo, setSelectedDateTo] = useState(new Date());
  const [maxDateFrom, setMaxDateFrom] = useState(new Date());
  const [maxDateMonth, setMaxDateMonth] = useState(new Date());
  const [minDateFrom, setMinDateFrom] = useState(undefined);
  const [selectedReport, setSelectedReport] = useState('');
  const [selectedUnit, setSelectedUnit] = useState('');
  const [reportError, setReportError] = useState('');
  const [finalDateError, setFinalDateError] = useState(false);
  const [initialDateError, setInitialDateError] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [dateFromError, setDateFromError] = useState(false);
  const [units, setUnits] = useState(null);
  const [unitError, setUnitError] = useState('');
  const [selectedDateMonth, setSelectedDateMonth] = useState(moment());
  const [dateMonthError, setDateMonthError] = useState(false);
  const [dateMonthFormatError, setDateMonthFormatError] = useState(false);
  const [dateRangeFormat, setDateRangeFormat] = useState('DD/MM/YYYY');

  const pdfSecurity = new Map();
  pdfSecurity.set('dailyBankingHistory', [
    [Report.actions.getDailyBankingHistoryByPeriod],
  ]);
  pdfSecurity.set('monthlyBankingHistory', [
    [Report.actions.getMonthlyBankingHistory],
  ]);
  const csvSecurity = new Map();
  csvSecurity.set('getFullDre', [[Report.actions.getDreCSV]]);
  csvSecurity.set('getDreByUnitCSV', [[Report.actions.getDreByUnitCSV]]);

  const listReports = [
    useSecurity({ value: 'getFullDre', label: 'DRE Total' }, [
      [Report.actions.getDreCSV],
    ]),
    useSecurity({ value: 'getDreByUnitCSV', label: 'DRE Individual' }, [
      [Report.actions.getDreByUnitCSV],
    ]),
    useSecurity(
      { value: 'dailyBankingHistory', label: 'Histórico Bancário (Diário)' },
      [[Report.actions.getDailyBankingHistoryByPeriod]]
    ),
    useSecurity(
      { value: 'monthlyBankingHistory', label: 'Histórico Bancário (Mensal)' },
      [[Report.actions.getMonthlyBankingHistory]]
    ),
  ].filter((x) => !!x);

  useEffect(() => {
    if (['getDreByUnitCSV'].includes(selectedReport)) {
      restApiClient.unit.getAll().then((e) => {
        setUnits(e.data);
      });
    }
  }, [selectedReport]);

  return (
    <Container>
      <HeaderContainer>
        <h1>Relatórios DRE</h1>
      </HeaderContainer>
      <AutoDiv>
        <SelectContainer>
          <FormControl
            required
            variant="outlined"
            size="small"
            error={!isEmpty(reportError)}
          >
            <InputLabel htmlFor="outlined-selectedUnit-native-simple">
              Selecione o tipo de Relatório
            </InputLabel>
            <Select
              value={selectedReport || ''}
              label="Selecione o tipo de Relatório"
              onChange={(e) => {
                setSelectedReport(e.target.value);
                setDateFromError(false);
                setDateMonthError(false);
                setDateMonthFormatError(false);
                setReportError('');
                switch (e.target.value) {
                  case 'dailyBankingHistory':
                    setExportCsvVisible(false);
                    setExportPdfVisible(true);
                    setDateIntervalVisible(true);
                    setSelectUnitVisible(false);
                    setDateIntervalMonthVisible(false);
                    setDateRangeFormat('DD/MM/YYYY');
                    break;
                  case 'monthlyBankingHistory':
                    setExportCsvVisible(false);
                    setExportPdfVisible(true);
                    setDateIntervalVisible(false);
                    setSelectUnitVisible(false);
                    setDateIntervalMonthVisible(true);
                    setDateRangeFormat('DD/MM/YYYY');
                    break;
                  case 'getFullDre':
                    setExportCsvVisible(true);
                    setExportPdfVisible(false);
                    setDateIntervalVisible(false);
                    setSelectUnitVisible(false);
                    setDateIntervalMonthVisible(true);
                    setDateRangeFormat('DD/MM/YYYY');
                    break;
                  case 'getDreByUnitCSV':
                    setExportCsvVisible(true);
                    setExportPdfVisible(false);
                    setDateIntervalVisible(true);
                    setSelectUnitVisible(true);
                    setDateIntervalMonthVisible(false);
                    setDateRangeFormat('MM/YYYY');
                    break;
                  default:
                    setExportCsvVisible(false);
                    setExportPdfVisible(false);
                    setDateIntervalVisible(false);
                    setSelectUnitVisible(false);
                    setDateIntervalMonthVisible(false);
                    setDateRangeFormat('DD/MM/YYYY');
                    break;
                }
              }}
            >
              {[
                <MenuItem value="" key={'empty'}>
                  <em>Nenhuma</em>
                </MenuItem>,
              ].concat(
                listReports?.map((item) => (
                  <MenuItem value={item.value} key={item.value}>
                    {item.label}
                  </MenuItem>
                ))
              )}
            </Select>
            <FormHelperText>
              {!isEmpty(reportError) ? reportError : ''}
            </FormHelperText>
          </FormControl>
        </SelectContainer>
        <Hidden xsUp={!selectUnitVisible}>
          <SelectContainer>
            <FormControl
              required
              variant="outlined"
              size="small"
              error={!isEmpty(unitError)}
            >
              <InputLabel htmlFor="outlined-selectedUnit-native-simple">
                Selecione uma unidade
              </InputLabel>
              <Select
                value={selectedUnit || ''}
                label="Selecione uma Unidade"
                onChange={(e) => {
                  setSelectedUnit(e.target.value);
                  setUnitError('');
                }}
              >
                {units?.values
                  .map((optionValue) => (
                    <MenuItem value={optionValue.id} key={optionValue.id}>
                      {optionValue.name}
                    </MenuItem>
                  ))

                  .concat([
                    <MenuItem value="" key={'empty'}>
                      <em>Nenhuma</em>
                    </MenuItem>,
                  ])}
              </Select>
              <FormHelperText>
                {!isEmpty(unitError) ? unitError : ''}
              </FormHelperText>
            </FormControl>
          </SelectContainer>
        </Hidden>
      </AutoDiv>
      <AutoDiv>
        <Hidden xsUp={!dateIntervalVisible}>
          <MuiPickersUtilsProvider utils={DayJsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-from"
              label="Data Inicial"
              format={dateRangeFormat}
              value={selectedDateFrom}
              views={
                dateRangeFormat === 'MM/YYYY'
                  ? [('year', 'month')]
                  : ['year', 'date', 'month']
              }
              onChange={(date) => {
                let crrDate = date?.toDate() ?? null;
                setDateFromError(false);
                setSelectedDateFrom(crrDate);
                setMinDateFrom(crrDate);
              }}
              KeyboardButtonProps={{
                'aria-label': 'Editar data',
              }}
              cancelLabel="Cancelar"
              okLabel="Selecionar"
              invalidDateMessage="Data em formato inválido."
              maxDate={maxDateFrom}
              maxDateMessage={`A data deve ser menor do que ${dayjs(
                maxDateFrom
              ).format(dateRangeFormat)}.`}
              onError={(value) => setInitialDateError(value)}
              helperText={dateFromError ? 'Este campo é obrigatório.' : ''}
              error={dateFromError}
            />
            <KeyboardDatePicker
              margin="normal"
              id="date-to"
              label="Data Final"
              format={dateRangeFormat}
              value={selectedDateTo}
              views={
                dateRangeFormat === 'MM/YYYY'
                  ? [('year', 'month')]
                  : ['year', 'date', 'month']
              }
              onChange={(date) => {
                setSelectedDateTo(date?.toDate());
                setMaxDateFrom(date?.toDate());
              }}
              KeyboardButtonProps={{
                'aria-label': 'Editar data',
              }}
              cancelLabel="Cancelar"
              okLabel="Selecionar"
              invalidDateMessage="Data em formato inválido."
              minDate={minDateFrom}
              minDateMessage={`A data deve ser maior que ${dayjs(
                minDateFrom
              ).format(dateRangeFormat)}.`}
              onError={(value) => setFinalDateError(value)}
            />
          </MuiPickersUtilsProvider>
        </Hidden>
      </AutoDiv>
      <AutoDiv>
        <Hidden xsUp={!dateIntervalMonthVisible}>
          <MuiPickersUtilsProvider utils={DayJsUtils}>
            <KeyboardDatePicker
              margin="normal"
              id="date-month"
              label="Mês/Ano"
              format="MM/YYYY"
              value={selectedDateMonth}
              views={['year', 'month']}
              onChange={(date) => {
                setDateMonthError(false);
                setSelectedDateMonth(moment(date?.toDate()));
              }}
              KeyboardButtonProps={{
                'aria-label': 'Editar data',
              }}
              cancelLabel="Cancelar"
              okLabel="Selecionar"
              invalidDateMessage="Data em formato inválido."
              maxDate={maxDateMonth}
              maxDateMessage={`O mês deve ser menor do que ${dayjs(
                maxDateMonth
              ).format('MM/YYYY')}.`}
              helperText={
                dateMonthError
                  ? 'Este campo é obrigatório.'
                  : dateMonthFormatError ?? ''
              }
              error={dateMonthError || dateMonthFormatError}
              onError={(error) => setDateMonthFormatError(error)}
            />
          </MuiPickersUtilsProvider>
        </Hidden>
      </AutoDiv>
      <FooterContainer>
        <AutoDiv>
          {fetching ? (
            <>
              <CircularProgress size={24} />
              <span> Processando Relatório</span>
            </>
          ) : (
            <>
              <Hidden xsUp={!exportCsvVisible}>
                <ButtonContainer>
                  <SecuredItem allowedActions={csvSecurity.get(selectedReport)}>
                    <ExportCsvButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={<FileCsv />}
                      onClick={async () => {
                        switch (selectedReport) {
                          case 'getFullDre':
                            if (selectedDateMonth) {
                              setFetching(true);
                              restApiClient.expenseType
                                .getDreCSV(
                                  moment(selectedDateMonth).format('MM-YYYY')
                                )
                                .then((e) => {
                                  setFetching(false);
                                });
                            } else {
                              setUnitError('Selecione uma opção válida.');
                            }
                            break;
                          case 'getDreByUnitCSV':
                            if (
                              selectedDateFrom &&
                              selectedDateTo &&
                              selectedUnit
                            ) {
                              setFetching(true);
                              restApiClient.expenseType
                                .getDreByUnitCSV(
                                  selectedUnit,
                                  moment(selectedDateFrom).format('MM-YYYY'),
                                  moment(selectedDateTo).format('MM-YYYY')
                                )
                                .then((e) => {
                                  setFetching(false);
                                });
                            } else {
                              setUnitError('Selecione uma opção válida.');
                            }
                            break;
                          default:
                            setReportError('Selecione uma opção válida.');
                            break;
                        }
                      }}
                    >
                      Exportar para CSV
                    </ExportCsvButton>
                  </SecuredItem>
                </ButtonContainer>
              </Hidden>
              <Hidden xsUp={!exportPdfVisible}>
                <ButtonContainer>
                  <SecuredItem allowedActions={pdfSecurity.get(selectedReport)}>
                    <ExportPdfButton
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={<FilePdf />}
                      onClick={async () => {
                        switch (selectedReport) {
                          case 'dailyBankingHistory':
                            if (
                              selectedDateFrom &&
                              !initialDateError &&
                              !finalDateError
                            ) {
                              setFetching(true);
                              await restApiClient.unitFinance
                                .getDailyBankingHistoryByPeriod(
                                  moment(selectedDateFrom).format('DD-MM-YYYY'),
                                  moment(selectedDateTo).format('DD-MM-YYYY')
                                )
                                .then((e) => {
                                  const doc =
                                    ReportDailyBankingHistory.buildPdf(
                                      moment(selectedDateFrom).format(
                                        'DD/MM/YYYY'
                                      ),
                                      moment(selectedDateTo).format(
                                        'DD/MM/YYYY'
                                      ),
                                      e.data
                                    );
                                  doc.save(
                                    `RELATORIO_HISTORICO_BANCÁRIO_DIARIO.pdf`
                                  );
                                  setFetching(false);
                                });
                            } else {
                              if (!initialDateError && !finalDateError)
                                setDateFromError(true);
                            }
                            break;
                          case 'monthlyBankingHistory':
                            if (
                              selectedDateMonth?.isValid() &&
                              !dateMonthError &&
                              !dateMonthFormatError
                            ) {
                              setFetching(true);
                              await restApiClient.unitFinance
                                .getMonthlyBankingHistory(
                                  selectedDateMonth.month() + 1,
                                  selectedDateMonth.year()
                                )
                                .then((e) => {
                                  const doc =
                                    ReportMonthlyBankingHistory.buildPdf(
                                      e.data,
                                      selectedDateMonth
                                    );
                                  doc.save(
                                    `RELATORIO_HISTORICO_BANCÁRIO_MENSAL_${selectedDateMonth.format(
                                      'MM_YYYY'
                                    )}.pdf`
                                  );
                                  setFetching(false);
                                });
                            } else {
                              if (!dateMonthFormatError)
                                setDateMonthError(true);
                            }
                            break;
                          default:
                            setReportError('Selecione uma opção válida.');
                            break;
                        }
                      }}
                    >
                      Exportar para PDF
                    </ExportPdfButton>
                  </SecuredItem>
                </ButtonContainer>
              </Hidden>
            </>
          )}
        </AutoDiv>
      </FooterContainer>
    </Container>
  );
}

export default DreReportList;
